import React from 'react';
import moment from 'moment';
import { IPage } from '../../../../interfaces/models/models/paginated-response.model';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import Table from '../../../../shared/table';

const tableColumns = ['Reservation ID', 'Name', 'Room Number', 'Check in', 'Check out', 'Guest Intelligence']

interface IGuestsTable {
    rows: any;
    paginationData?: IPage;
    rowsLoading: boolean;
    onClickDetails: (id: string) => void;
    setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
}

const GuestsTable = ({
    rows,
    paginationData,
    rowsLoading,
    onClickDetails,
    setPaginationState,
}: IGuestsTable) => {
    return (
        <Table
            columns={tableColumns}
            paginationData={paginationData}
            setPaginationState={setPaginationState}
        >
            {rowsLoading ?
                <>
                    {[...Array(4)].map((x, i) => {
                        return (
                            <tr key={i}>
                                {[...Array(tableColumns?.length || 1)].map((x, j) => {
                                    return (
                                        <td key={j} className='td-1 !min-w-[100%] text-center py-5'><span></span></td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </>
                : <>
                    {rows?.length > 0 && rows?.map((row: any, idx: number) => {
                        return (
                            <tr key={idx} className='bg-white border-b hover:bg-gray-50 cursor-pointer hover:bg-gray-50' onClick={() => onClickDetails(row?.reservationId || row?._id || row?.id)}>
                                <td className='px-6 py-4'>{row?.reservationId}</td>
                                <td className='px-6 py-4'>{row?.firstName} {row?.lastName}</td>
                                <td className='px-6 py-4'>{row?.roomId}</td>
                                <td className='px-6 py-4'>{moment(row?.checkinDate)?.format('DD/MM/YYYY')}</td>
                                <td className='px-6 py-4'>{row?.checkoutDate ? moment(row?.checkoutDate)?.format('DD/MM/YYYY') : '-'}</td>
                                <td className={`px-6 py-4 ${(row?.guests || row?.guests?.length > 0) ? 'text-[#008000]' : 'text-[#FF0000]'}`}>{(row?.guests || row?.guests?.length > 0) ? 'Information available' : 'Information unavailable'}</td>
                            </tr>
                        )
                    })}
                </>
            }
        </Table>
    )
}

export default GuestsTable;